import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import axios from "axios";

import { dataService } from "../shared";
import {
  GET_ACCOUNT,
  UPDATE_ACCOUNT,
  GET_SUBJECTS,
  GET_TEACHERS,
  GET_EXAMFEES,
  GET_TEACHER,
  GET_PARENTS,
  GET_PARENTSTOTAL,
  GET_EXAMS,
  GET_EXAMSTOTAL,
  UPDATE_EXAM,
  GET_SCHOOLYEAR,
  GET_SCHOOLYEARS,
  UPDATE_SCHOOLYEAR,
  DELETE_SCHOOLYEAR,
  ADD_SCHOOLYEAR,
  SET_SCHOOLYEAR,
  UPDATE_TEACHER,
  GET_TRANSACTIONS,
  GET_CREDITRECORDS,
  ADD_CREDITRECORD,
  DELETE_PARENT,
  UPDATE_EXAMFEE,
  GET_LOCATIONS,
  UPDATE_LOCATION,
  ADD_LOCATION,
  DELETE_LOCATION,
  GET_PENDINGACCOUNTS,
  DELETE_PENDINGACCOUNT
} from "./mutation-types";

Vue.use(Vuex);

const state = () => ({
  status: "",
  token: "",
  user: {},
  account: {},
  teacher: {},
  subjects: [],
  teachers: [],
  parents: [],
  parentsTotal: 0,
  error: "",
  snackbar: false,
  snackbarColor: "error",
  examGradeType: [
    "Ungraded",
    "Distinction",
    "First Division",
    "Second Division",
    "Ordinary Pass",
    "Retry Allowed",
    "Unsuccessful",
  ],
  examFees: [],
  exams: [],
  examsTotal: 0,
  schoolYear: {},
  schoolYears: [],
  transactions: [],
  fullScreenLoading: false,
  creditRecords: [],
  locations: [],
  pendingAccounts: []
});

const mutations = {
  [GET_ACCOUNT](state, account) {
    state.account = account;
  },
  [UPDATE_ACCOUNT](state, account) {
    state.account = account;
  },
  [UPDATE_EXAM](state, exam) {
    const index = state.exams.findIndex((h) => h.id === exam.id);
    state.exams.splice(index, 1, exam);
    state.exams = [...state.exams];
  },
  [UPDATE_SCHOOLYEAR](state, schoolYear) {
    const index = state.schoolYears.findIndex((h) => h.id === schoolYear.id);
    state.schoolYears.splice(index, 1, schoolYear);
    state.schoolYears = [...state.schoolYears];
  },
  [UPDATE_EXAMFEE](state, examFee) {
    const index = state.examFees.findIndex((h) => h.id === examFee.id);
    state.examFees.splice(index, 1, examFee);
    state.examFees = [...state.examFees];
  },
  [UPDATE_LOCATION](state, location) {
    const index = state.locations.findIndex((h) => h.id === location.id);
    state.locations.splice(index, 1, location);
    state.locations = [...state.locations];
  },
  [ADD_SCHOOLYEAR](state, schoolYear) {
    state.schoolYears.unshift(schoolYear); // mutable addition
  },
  [ADD_LOCATION](state, location) {
    state.locations.unshift(location); // mutable addition
  },
  [ADD_CREDITRECORD](state, creditRecord) {
    state.creditRecords.unshift(creditRecord);
  },
  [GET_SUBJECTS](state, subjects) {
    state.subjects = subjects;
  },
  [GET_TEACHERS](state, teachers) {
    state.teachers = teachers;
  },
  [GET_PENDINGACCOUNTS](state, pendingAccounts) {
    state.pendingAccounts = pendingAccounts;
  },
  [UPDATE_TEACHER](state, teacher) {
    const index = state.teachers.findIndex((h) => h.id === teacher.id);
    state.teachers.splice(index, 1, teacher);
    state.teachers = [...state.teachers];
  },
  [GET_EXAMFEES](state, examFees) {
    state.examFees = examFees;
  },
  [GET_TEACHER](state, teacher) {
    state.teacher = teacher;
  },
  [GET_PARENTS](state, parents) {
    state.parents = parents;
  },
  [GET_LOCATIONS](state, locations) {
    state.locations = locations;
  },
  [GET_PARENTSTOTAL](state, parentsTotal) {
    state.parentsTotal = parentsTotal;
  },
  [GET_EXAMS](state, exams) {
    state.exams = exams;
  },
  [GET_EXAMSTOTAL](state, examsTotal) {
    state.examsTotal = examsTotal;
  },
  [GET_SCHOOLYEAR](state, schoolYear) {
    state.schoolYear = schoolYear;
  },
  [GET_SCHOOLYEARS](state, schoolYears) {
    state.schoolYears = schoolYears;
  },
  [SET_SCHOOLYEAR](state, schoolYear) {
    state.schoolYear = schoolYear;
  },
  [DELETE_SCHOOLYEAR](state, schoolYearId) {
    state.schoolYears = [
      ...state.schoolYears.filter((p) => p.id !== schoolYearId),
    ];
  },
  [DELETE_LOCATION](state, locationId) {
    state.locations = [
      ...state.locations.filter((p) => p.id !== locationId),
    ];
  },
  [DELETE_PARENT](state, accountId) {
    state.parents = [...state.parents.filter((p) => p.id !== accountId)];
    state.parentsTotal = state.parentsTotal - 1;
  },
  [DELETE_PENDINGACCOUNT](state, pendingAccountId) {
    state.pendingAccounts = [...state.pendingAccounts.filter((p) => p.id !== pendingAccountId)];
  },
  [GET_TRANSACTIONS](state, transactions) {
    state.transactions = transactions;
  },
  [GET_CREDITRECORDS](state, creditRecords) {
    state.creditRecords = creditRecords;
  },
  auth_request(state) {
    state.status = "loading";
  },
  auth_success(state, { token, user }) {
    state.status = "success";
    state.token = token;
    state.user = user;
  },
  auth_error(state) {
    state.status = "error";
  },
  logout(state) {
    console.log("in mutation logout");
    state.status = "";
    state.token = "";
    state.user = {};
    state.account = null;
    sessionStorage.clear();
  },
  register(state) {
    state.status = "registering";
  },
};

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
  state,
  mutations,
  actions: {
    async login({ commit }, model) {
      try {
        const response = await axios.post(
          process.env.VUE_APP_SERVICE_URL + "/login",
          model
        );
        const token = response.data.token;
        const user = response.data.user;
        // Add the following line:
        axios.defaults.headers.common["Authorization"] = token;
        commit("auth_success", { token, user });
      } catch (err) {
        commit("auth_error");
        axios.defaults.headers.common["Authorization"] = "";
        throw err;
      }
    },
    async linkStudentAction({ commit }, { model, token }) {
      console.log("in linkStudentAction. model", model);
      const account = await dataService.linkStudent(model, token);
      if (account != null) {
        commit(UPDATE_ACCOUNT, account);
      }
    },
    register({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("register");
        axios({
          url: process.env.VUE_APP_SERVICE_URL + "/register",
          data: user,
          method: "POST",
        })
          .then((resp) => {
            commit("logout");
            resolve(resp);
          })
          .catch((error) => {
            commit("auth_error");
            console.log("in store catch", error);
            reject(error);
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit("logout");
        //localStorage.removeItem("token");
        delete axios.defaults.headers.common["Authorization"];
        resolve();
      });
    },
    async getTransactionsAction({ commit }, { id, token }) {
      const transactions = await dataService.getTransactions(id, token);
      if (transactions != null) {
        commit(GET_TRANSACTIONS, transactions);
      }
    },
    async getCreditRecordsAction({ commit }, { id, token }) {
      const creditRecords = await dataService.getCreditRecords(id, token);
      if (creditRecords != null) {
        commit(GET_CREDITRECORDS, creditRecords);
      }
    },
    async getTeacherAction({ commit }, { id, token }) {
      const teacher = await dataService.getTeacher(id, token);
      commit(GET_TEACHER, teacher);
    },
    async getAccountAction({ commit }, { id, token }) {
      const account = await dataService.getAccount(id, token);
      commit(GET_ACCOUNT, account);
    },
    async updateAccountAction({ commit }, { account, token }) {
      console.log("in updateAccountAction. account", account);
      const updatedAccount = await dataService.updateAccount(account, token);
      commit(UPDATE_ACCOUNT, updatedAccount);
    },
    async updatePasswordAction({ commit }, { model, token }) {
      console.log("in updatePasswordAction. model", model);
      const account = await dataService.updatePassword(model, token);
      if (account != null) {
        if (account.accountType !== 3) {
          commit(UPDATE_ACCOUNT, account);
        }
      }
    },
    async addChildAction({ commit }, { model, token }) {
      console.log("in addChildAction. model", model);
      const account = await dataService.addChild(model, token);
      if (account != null) {
        commit(UPDATE_ACCOUNT, account);
      }
    },
    async updateChildAction({ commit }, { model, token }) {
      console.log("in updateChildAction. model", model);
      const account = await dataService.updateChild(model, token);
      if (account != null) {
        commit(UPDATE_ACCOUNT, account);
      }
    },
    async getSchoolYearAction({ commit }) {
      const schoolYear = await dataService.getSchoolYearCurrent();
      commit(GET_SCHOOLYEAR, schoolYear);
    },
    async getSchoolYearsAction({ commit }) {
      const schoolYears = await dataService.getSchoolYears();
      if (schoolYears != null) {
        commit(GET_SCHOOLYEARS, schoolYears);
      }
    },
    async getSubjectsAction({ commit }) {
      const subjects = await dataService.getSubjects();
      if (subjects != null) {
        commit(GET_SUBJECTS, subjects);
      }
    },
    async getTeachersAction({ commit }) {
      const teachers = await dataService.getTeachers();
      if (teachers != null) {
        commit(GET_TEACHERS, teachers);
      }
    },
    async getPendingAccountsAction({ commit }) {
      const pendingAccounts = await dataService.getPendingAccounts();
      if (pendingAccounts != null) {
        commit(GET_PENDINGACCOUNTS, pendingAccounts);
      }
    },
    async getParentsAction(
      { commit },
      { token, page, itemsPerPage, sortBy, search }
    ) {
      const parents = await dataService.getParents(
        token,
        page,
        itemsPerPage,
        sortBy,
        search
      );
      if (parents != null) {
        commit(GET_PARENTS, parents.data);
        commit(GET_PARENTSTOTAL, parents.totalCount);
      }
    },
    async getExamFeesAction({ commit }) {
      const examFees = await dataService.getExamFees();
      if (examFees != null) {
        commit(GET_EXAMFEES, examFees);
      }
    },
    async getLocationsAction({ commit }) {
      console.log("getLocationsAction");
      const locations = await dataService.getLocations();
      console.log("getLocationsAction result", locations);
      if (locations != null) {
        commit(GET_LOCATIONS, locations);
      }
    },
    async getExamsAction(
      { commit },
      { id, isHideFinalized, subjectId, gradeLevel, token, page, itemsPerPage, sortBy, search }
    ) {
      const exams = await dataService.getExams(
        id,
        isHideFinalized,
        subjectId,
        gradeLevel,
        token,
        page,
        itemsPerPage,
        sortBy,
        search
      );
      if (exams != null) {
        commit(GET_EXAMS, exams.data);
        commit(GET_EXAMSTOTAL, exams.totalCount);
      }
    },
    async addExamRegistrationAction({ commit }, { model, token }) {
      const account = await dataService.addExamRegistration(model, token);
      if (account != null) {
        commit(UPDATE_ACCOUNT, account);
      }
    },
    async refundExamRegistrationAction({ commit }, { model, token }) {
      const account = await dataService.refundExamRegistration(model, token);
      if (account != null) {
        commit(UPDATE_ACCOUNT, account);
      }
    },
    async deleteExamRegistrationAction({ commit }, { model, token }) {
      const account = await dataService.deleteExamRegistration(model, token);
      if (account != null) {
        commit(UPDATE_ACCOUNT, account);
      }
    },
    async deleteChildAction({ commit }, { model, token }) {
      const account = await dataService.deleteChild(model, token);
      if (account != null) {
        commit(UPDATE_ACCOUNT, account);
      }
    },
    async deleteSchoolYearAction({ commit }, { model, token }) {
      const schoolYearId = await dataService.deleteSchoolYear(model, token);
      commit(DELETE_SCHOOLYEAR, schoolYearId);
    },
    async deleteLocationAction({ commit }, { model, token }) {
      const locationId = await dataService.deleteLocation(model, token);
      commit(DELETE_LOCATION, locationId);
    },
    async deleteParentAction({ commit }, { model, token }) {
      const accountId = await dataService.deleteParent(model, token);
      commit(DELETE_PARENT, accountId);
    },
    async deletePendingAccountAction({ commit }, { model, token }) {
      const pendingAccountId = await dataService.deletePendingAccount(model, token);
      commit(DELETE_PENDINGACCOUNT, pendingAccountId);
    },
    async confirmPendingAccountAction({ commit }, { model, token }) {
      const pendingAccountId = await dataService.confirmPendingAccount(model, token);
      console.log("the prndingAccountid", pendingAccountId);
      commit(DELETE_PENDINGACCOUNT, pendingAccountId);
    },
    async updateExamRegistrationCreditAction({ commit }, { model, token }) {
      const account = await dataService.updateExamRegistrationCredit(
        model,
        token
      );
      if (account != null) {
        commit(UPDATE_ACCOUNT, account);
      }
    },
    async updateExamRegistrationPaidAction({ commit }, { model, token }) {
      const account = await dataService.updateExamRegistrationPaid(
        model,
        token
      );
      if (account != null) {
        commit(UPDATE_ACCOUNT, account);
      }
    },
    async updateExamRegistrationAction({ commit }, { model, token }) {
      const account = await dataService.updateExamRegistration(model, token);
      if (account != null) {
        commit(UPDATE_ACCOUNT, account);
      }
    },
    async updateExamRegistrationMarksAction({ commit }, { model, token }) {
      const exam = await dataService.updateExamRegistrationMarks(model, token);
      if (exam != null) {
        commit(UPDATE_EXAM, exam);
      }
    },
    async updateSchoolYearAction({ commit }, { model, token }) {
      const schoolYear = await dataService.updateSchoolYear(model, token);
      if (schoolYear != null) {
        commit(UPDATE_SCHOOLYEAR, schoolYear);
      }
    },
    async updateLocationAction({ commit }, { model, token }) {
      const location = await dataService.updateLocation(model, token);
      if (location != null) {
        commit(UPDATE_LOCATION, location);
      }
    },

    async updateExamFeeAction({ commit }, { model, token }) {
      const examFee = await dataService.updateExamFee(model, token);
      if (examFee != null) {
        commit(UPDATE_EXAMFEE, examFee);
      }
    },
    async addSchoolYearAction({ commit }, { model, token }) {
      const schoolYear = await dataService.addSchoolYear(model, token);
      if (schoolYear != null) {
        commit(ADD_SCHOOLYEAR, schoolYear);
      }
    },
    async addLocationAction({ commit }, { model, token }) {
      const location = await dataService.addLocation(model, token);
      if (location != null) {
        commit(ADD_LOCATION, location);
      }
    },
    async addCreditRecordAction({ commit }, { model, token }) {
      const creditRecord = await dataService.addCreditRecord(model, token);
      if (creditRecord != null) {
        commit(ADD_CREDITRECORD, creditRecord);
      }
    },
    setSchoolYearAction({ commit }, model) {
      commit(SET_SCHOOLYEAR, model);
    },
    async updateTeacherIsActiveAction({ commit }, { model, token }) {
      const teacher = await dataService.updateTeacherIsActive(model, token);
      if (teacher != null) {
        commit(UPDATE_TEACHER, teacher);
      }
    },
    async updateExamRegistrationCcAction({ commit }, { model, token }) {
      const account = await dataService.payCart(model, token);
      if (account != null) {
        commit(UPDATE_ACCOUNT, account);
      }
    },
    async updateAccountEmailAction({ commit }, { model, token }) {
      const account = await dataService.updateAccountEmail(model, token);
      if (account != null) {
        if (account.accountType !== 3) {
          commit(UPDATE_ACCOUNT, account);
        }
      }
    },
    async moveChildrenAction({ commit }, { model, token }) {
      const account = await dataService.moveChildren(model, token);
      if (account != null) {
        commit(UPDATE_ACCOUNT, account);
      }
    },
  },
  modules: {},
  getters: {
    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status,
    isTeacher: (state) => !!state.token && state.user.accountType == 2,
    isAdmin: (state) => !!state.token && state.user.accountType == 3,
  },
});
